import { WEDDING } from "@/data/wedding";

const Diamond = () => (
  <svg
    viewBox="0 0 12 12"
    className="h-3 w-3 shrink-0 text-terracotta"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M6 0l1.8 4.2L12 6 7.8 7.8 6 12 4.2 7.8 0 6l4.2-1.8z" />
  </svg>
);

const ITEMS = [
  `${WEDDING.bride} & ${WEDDING.groom}`,
  WEDDING.dateShort,
  "Domaine de l'Établière",
];

const Sequence = ({ ariaHidden }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center gap-10 pr-10">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-10">
        <span className="whitespace-nowrap font-serif text-2xl italic text-ink">
          {item}
        </span>
        <Diamond />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="marquee overflow-hidden border-y border-line bg-[#FCEFED] py-5">
      <div className="marquee-track flex w-max">
        <Sequence ariaHidden={false} />
        <Sequence ariaHidden />
      </div>
    </div>
  );
}
